import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

export const apiHorariosService = {
  getAllPageable: async (idEmpresa, page, size) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.HORARIOS.GET_ALL(idEmpresa, page, size),
      {
        method: "GET",
      }
    );

    return response.json();
  },
  getAll: async (idEmpresa, page, size) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.HORARIOS.GET_ALL(idEmpresa, page, size),
      { method: "GET" }
    );
    return response.json();
  },
  deleteById: async (idHorario) => {
    const response = await requestWithAuth(API_ENDPOINTS.HORARIOS.DELETE(idHorario), {
      method: "DELETE",
    });

    return response.json();
  },
  getById: async (id) => {
    const response = await requestWithAuth(API_ENDPOINTS.HORARIOS.ONE(id), {
      method: "GET",
    });
    return response.json();
  },
  create: async (json) => {
    const response = await requestWithAuth(API_ENDPOINTS.HORARIOS.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });

    return response.json();
  }, //update(empresa.id, props.horario.id,json)
  update: async (idEmpresa, idHorario, json) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.HORARIOS.UPDATE(idEmpresa, idHorario),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(json),
      }
    );

    return response.json();
  },
};
